import { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar";
import { getApiSetting, multiFocus, postApiSetting, stopTags, typeFloatNumber, typeNumber } from "../assets/functions";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import { NavLink,useNavigate } from "react-router-dom";

export default function AMerchantManagement({setAuth}) {
     const navigate = useNavigate();

    const { register, handleSubmit, formState: { errors } } = useForm();
    const { register: register2, handleSubmit: handleSubmit2, reset: reset2, formState: { errors: errors2 } } = useForm();
    const { register: register3, handleSubmit: handleSubmit3, reset: reset3, formState: { errors: errors3 } } = useForm();

    const [aMerchantData, setAMerchantData] = useState([]);
    const [meDetails, setMeDetails] = useState({});
    const [editForm, setEditForm] = useState(false);
    const [fetchProcDtl, setFetchProcDtl] = useState({});
    const [fetchProcDtl_2, setFetchProcDtl_2] = useState({});

    const [procData, setProcData] = useState([]);
    const [procDataPayout, setProcDataPayout] = useState([]);

    const [resName,setResName] = useState();
    const [resId,setResId] = useState();

    const pmtModeRef = useRef(null);
    const meTypeRef = useRef(null);
    const statusRef = useRef(null);
    const pmtModeCatRef = useRef(null);
    const prodRef = useRef(null);

//     useEffect(()=>{
        
//         loadMaxData()
//     })

//    async function loadMaxData(){
//             try {
//                 let res = await fetch('/api/Admin/Management/fetchAprrovedMerchants', getApiSetting());
//                 let result 
//                 if (res.status === 200) {
//                     result = await res.json();
//                     if(result){
//                         console.log("result--",result)
//                     }
                   
//                 }
//                  else if(res.status === 401)
//                 { 
//                     setAuth(false)
//                     toast.error("Session Expired !", {position: 'top-center',});
//                     navigate("/");                  
//                     sessionStorage.clear();
//                 }
//             } catch (error) { console.log(error) }
        
//    }



    useEffect(() => {
        (async () => {
            try {
                // let res = await fetch('/api/Admin/Management/fetchAprrovedMerchants', getApiSetting());
                let res = await fetch('/Admin/api/Admin/Management/fetchAprrovedMerchants', getApiSetting());
                let result 
                if (res.status === 200) {
                    // console.log("----result.data.responseData-----",result.data.responseData)
                    result = await res.json();
                    setAMerchantData(result.data.responseData)
                    // console.log("result.data.responseData---",result.data.responseData)
                }
                 else if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }
            } catch (error) { console.log(error) }
        })()
        ressellerNameFun()
    }, [editForm])

    
    async function ressellerNameFun(){
        try {
            // let res = await fetch('/admin/api/Admin/Management/fetchAprrovedMerchants', getApiSetting());
            let res = await fetch('/Admin/api/Admin/Management/fetchAllReseller', getApiSetting());
            let result 
            if (res.status === 200) {
                result = await res.json();
                setResName(result.data.responseData)
                
            }
             else if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }
        } catch (error) { console.log(error) }
    }
    async function resIdHandler(reName){
        try {
            // let res = await fetch('/admin/api/Admin/Management/fetchAprrovedMerchants', getApiSetting());
            let res = await fetch(`/Admin/api/Admin/Management/fetchAllResellerId/${reName}`, getApiSetting());
            let result 
            if (res.status === 200) {
                result = await res.json();
                setResId(result.data.responseData)
                meDetails.reUserId=null;
                // console.log("resid--",result)
                
            }
             else if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }
        } catch (error) { console.log(error) }
    }
    useEffect(() => {
        // console.log(meDetails)
        let pmchecks = pmtModeRef.current.querySelectorAll(`input[type="checkbox"]`);
        let pmcchecks = pmtModeCatRef.current.querySelectorAll(`input[type="checkbox"]`);
        let prodchecks = prodRef.current.querySelectorAll(`input[type="checkbox"]`);
        let mtchecks = meTypeRef.current.querySelectorAll(`input[type="radio"]`);
        let statuschecks = statusRef.current.querySelectorAll(`input[type="radio"]`);
        pmchecks.forEach(item => item.checked = false)
        pmcchecks.forEach(item => item.checked = false)
        prodchecks.forEach(item => item.checked = false)
        mtchecks.forEach(item => item.checked = false)
        statuschecks.forEach(item => item.checked = false)

        document.getElementById('currency').value = meDetails.currency;
        document.getElementById('payinChargeDeductionMode').value = meDetails.payinChargeDeductionMode;
        document.getElementById('ipCheck').value = meDetails.ipCheck;

        if (meDetails.paymentMode) {
            let modeList = meDetails.paymentMode.split(',');
            modeList.forEach((item) => {
                pmtModeRef.current.querySelector(`input[value="${item}"]`).checked = true;
            })
        }
        if (meDetails.paymodeCategory) {
            let modeList = meDetails.paymodeCategory.split(',');
            modeList.forEach((item) => {
                pmtModeCatRef.current.querySelector(`input[value="${item}"]`).checked = true;
            })
        }
        if (meDetails.products) {
            let modeList = meDetails.products.split(',');
            modeList.forEach((item) => {
                prodRef.current.querySelector(`input[value="${item}"]`).checked = true;
            })
        }
        if (meDetails.merchantType) {
            let modeList = meDetails.merchantType.split(',');
            modeList.forEach((item) => {
                meTypeRef.current.querySelector(`input[value="${item}"]`).checked = true;
            })
        }
        if (meDetails.status) {
            let modeList = meDetails.status.split(',');
            modeList.forEach((item) => {
                statusRef.current.querySelector(`input[value="${item}"]`).checked = true;
            })
        }
    }, [editForm])

    const editMeDetail = (data) => {
        console.log("data---",data)
        setEditForm(true)
        multiFocus('._editP')
        setMeDetails(data)
        fetchProc('fetchProcAndCharges',data.userId, data.mid);
        fetchProc('fetchProcAndChargesPayout',data.userId, data.mid);
    }

    const submitMeDetailForm = async (data) => {
        console.log("data--",data)
        let products = data.products.toString();
        let paymentMode = data.paymentMode.toString();
        let paymodeCategory = data.paymodeCategory.toString();
        // console.log(paymentMode)
        // return false;
        if (!data.products || data.products.length < 1) {
            alert('Please select atleast one payment mode.')
            return false;
        }
        if (!data.merchantType) {
            alert('Merchant type is required.')
            return false;
        }
        if (!data.paymentMode || data.paymentMode.length < 1) {
            alert('Please select atleast one payment mode.')
            return false;
        }
        if (!data.paymodeCategory || data.paymodeCategory.length < 1) {
            alert('Please select atleast one payment mode category')
            return false;
        }
        // console.log({...data,paymentMode,products,paymodeCategory,userId:meDetails.userId})
        // return false;
        // console.log("data--",data)
        let settings = postApiSetting({...data,paymentMode,products,paymodeCategory,userId:meDetails.userId })
        try {
            // let res = await fetch('/api/Admin/Management/updateAprMerchants', settings);
            let res = await fetch('/Admin/api/Admin/Management/updateAprMerchants', settings);
            let result
            console.log(res)
            console.log(result)
            if (res.status !== 200) {
                 if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }else{
                    alert('something went wrong : ' + res.status)
                }
            } else {
                result = await res.json();
                if (result.statusCode === '0') {
                    alert('SUCCESS : ' + result.status)
                    // setEditForm(false)
                } else {
                    alert('FAILED : ' + result.status)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const fetchProc = async (e, userId, mid) => {
        if(typeof e === 'string'){
            var apiEndPoint = e;
        }else{
            let formId = e.target.closest('.addprocbox').id;
            apiEndPoint = formId === 'payin' ? 'fetchProcAndCharges' : 'fetchProcAndChargesPayout';
        }

        try {
            // let res = await fetch(`/admin/api/Admin/Management/fetchProcAndCharges/${userId}/${mid}`, getApiSetting());
            let res = await fetch(`/Admin/api/Admin/Management/${apiEndPoint}/${userId}/${mid}`, getApiSetting());
            let result
            // console.log(result)
            if (res.status === 200) {
                result = await res.json();
                if (result.data && result.data.length > 0) {
                    if(apiEndPoint === 'fetchProcAndCharges') setProcData(result.data);
                    else setProcDataPayout(result.data);
                }
            }
             else if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }
        } catch (error) { console.log(error) }
    }

    const submitAddProc = async (data,e) => {
        let formId = e.target.closest('.addprocbox').id;
        let apiEndPoint = formId==='payin'?'AddProcAndCharges':'AddProcAndChargesPayout';
        let { mid, userId } = meDetails;
        try {
            // let res = await fetch(`admin/api/Admin/Management/AddProcAndCharges`, postApiSetting({ ...data, mid, userId }));
            let res = await fetch(`/Admin/api/Admin/Management/${apiEndPoint}`, postApiSetting({ ...data, mid, userId }));
            // let res = await fetch(`/api/Admin/Management/AddProcAndCharges`, postApiSetting({ ...data, mid, userId }));
            let result
            if (res.status !== 200) {
                 if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }else{
                alert('something went wrong : ' + res.status)
            }
            } else {
                result = await res.json();
                if (result.statusCode === '0') {
                    alert('SUCCESS : ' + result.status)
                    fetchProc(e, userId, mid)
                    if(formId==='payin'){
                        reset2()
                        setFetchProcDtl({})
                    }else{
                        reset3()
                        setFetchProcDtl_2({})
                    }
                } else {
                    alert('FAILED : ' + result.status)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const deleteProc = async (e,id) => {
        let formId = e.target.closest('.addprocbox').id;
        let apiEndPoint = formId==='payin'?'DeleteProcAndCharges':'DeleteProcAndChargesPayout';
        let { mid, userId } = meDetails;
        try {
            // let res = await fetch(`admin/api/Admin/Management/DeleteProcAndCharges/${id}`, getApiSetting());
            let res = await fetch(`/Admin/api/Admin/Management/${apiEndPoint}/${id}`, getApiSetting());
            let result 
            if (res.status !== 200) {
                if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }else{
                alert('something went wrong : ' + res.status)
            } 
            } else {
                result = await res.json();
                if (result.statusCode === '0') {
                    alert('SUCCESS : ' + result.status)
                    fetchProc(e,userId, mid)
                } else {
                    alert('FAILED : ' + result.status)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const editProc = async (e, id) => {
        try {
            let formId = e.target.closest('.addprocbox').id;
            let apiEndPoint = formId==='payin'?'UpdateProcAndCharges':'UpdateProcAndChargesPayout';

            let editElems = e.target.closest('tr').querySelectorAll('._editProc');
            let editedData = { id: id };
            editElems.forEach(({ name, value }) => {
                Object.assign(editedData, { [name]: value })
            })
            // console.log(editedData)
            // let res = await fetch(`admin/api/Admin/Management/UpdateProcAndCharges`, postApiSetting(editedData));
            let res = await fetch(`/Admin/api/Admin/Management/${apiEndPoint}`, postApiSetting(editedData));
            let result
            // console.log(res)
            // console.log(result)
            if (res.status !== 200) {
                if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }else{
                alert('something went wrong : ' + res.status)
                }
            } else {
                result = await res.json();
                if (result.statusCode === '0') {
                    alert('SUCCESS : ' + result.status)
                } else {
                    alert('FAILED : ' + result.status)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getProcObj = (e) => {
        let reqAry = [];
        let dataAry = [];
        let data = { procName:'', paymentMode:'', paymentModeCategory:'' };
        e.target.closest('form').querySelectorAll('._getmid').forEach(elem => {
            dataAry.push(elem.value)
            if(elem.value && elem.value !== ''){
                reqAry.push(elem.value)
            }
        })
        let updatedData = {...data,procName:dataAry[0],paymentMode:dataAry[1],paymentModeCategory:dataAry[2]}
        return [updatedData,reqAry];
    }

    const getProcMid = async (e) => {
        try {
            let [data,reqAry] = getProcObj(e);
            if(reqAry.length === 3){
                // let res = await fetch('admin/api/Admin/Processor/fetchProcMid', postApiSetting(data));
                let res = await fetch('/Admin/api/Admin/Processor/fetchProcMid', postApiSetting(data));
                let result 
                // console.log(res)
                // console.log(result)
                if (res.status !== 200) {if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }else{
                    alert('something went wrong : ' + res.status)
                }
                } else {
                    result = await res.json();
                    if (result.statusCode === '0') {
                        if(result.data && result.data.length > 0){
                            alert('SUCCESS : ' + result.status)
                            showProcMids(e,result.data)
                        }else{
                            alert('SUCCESS : '+"Mid Not Found !!")
                            showProcMids(e,[])
                        }
                    } else {
                        alert('FAILED : ' + result.status)
                    }
                }
            }
        } catch (error) {
            console.log(error)   
        }
    }

    const showProcMids = (e,data) => {
        // console.log(data)
        let opt = '<option value="">--Select--</option>';
        data.forEach((item)=>{
            opt += `<option value='${item}'>${item}</option>`;
        })
        e.target.closest('form').querySelector('._procmid').innerHTML = opt;
    }

    const getProcDetails = async (e) => {
        //console.log()
        try {
            let procMid = e.target.value;
            if(procMid !== ''){
                let [data] = getProcObj(e);
                // let res = await fetch('/admin/api/Admin/Processor/fetchProcDetails', postApiSetting({...data,procMid}));
                let res = await fetch('/Admin/api/Admin/Processor/fetchProcDetails', postApiSetting({...data,procMid}));
                if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }else{
                
                let result = await res.json();
                if(e.target.closest('.addprocbox').id === 'payin'){
                    setFetchProcDtl(result.data)
                    setFetchProcDtl_2({})
                    multiFocus('._focusProc') 
                }
                else if(e.target.closest('.addprocbox').id === 'payout'){
                    setFetchProcDtl({})
                    setFetchProcDtl_2(result.data)
                    multiFocus('._focusProc2') 
                }
            }
            }   
        } catch (error) {
            console.log(error)
        }
    } 
    
    // console.log(fetchProcDtl)

    return (<>
        {/* <SidebarNavigation /> */}
        <div className="dashboard-page w-100">
            <Navbar title="MERCHANT MANAGEMENT" />
            <div className="container-fluid pe-3">
                <div className="main-content my-3">
                    <h6 className="mb-3">MERCHANT MANAGEMENT ( APPROVED )</h6>
                    <div className="table-responsive" style={{ display: editForm ? 'none' : 'block' }}>
                        <table className="table table-bordered com-table">
                            <thead>
                                <tr>
                                    <th>User Id</th>
                                    <th>Mid</th>
                                    <th>Description</th>
                                    <th>Owner Name</th>
                                    <th>Mobile No</th>
                                    <th>Email Id</th>
                                    <th>Alternate Mobile No</th>
                                    <th>Business Type</th>
                                    <th>City</th>
                                    <th>State</th>
                                    <th>Country</th>
                                    <th>Legal Name</th>
                                    <th>Locality/Address</th>
                                    <th>Company/StoreName</th>
                                    <th>Nature Of Business</th>
                                    <th>Pan No</th>
                                    <th>Adhar No</th>
                                    <th>Pin Code</th>
                                    <th>Gst No</th>
                                    <th>Store Type</th>
                                    <th>Status</th>
                                    <th>Creation Date</th>
                                    <th>Modification Date</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {aMerchantData.length === 0 ? <tr><td colSpan={11}>Not Found</td></tr> :
                                    aMerchantData.map((item) => {
                                        return (
                                            <tr key={item.id}>
                                                <td>{item.userId}</td>
                                                <td>{item.mid}</td>
                                                <td>{item.description}</td>
                                                <td>{item.ownerName}</td>
                                                <td>{item.mobileNo}</td>
                                                <td>{item.emailId}</td>
                                                <td>{item.alternateMobileNo}</td>
                                                <td>{item.businessType}</td>
                                                <td>{item.City}</td>
                                                <td>{item.state}</td>
                                                <td>{item.country}</td>
                                                <td>{item.legalName}</td>
                                                <td>{item.localityOrAddress}</td>
                                                <td>{item.companyOrStoreName}</td>
                                                <td>{item.natureOfBusiness}</td>
                                                <td>{item.panNo}</td>
                                                <td>{item.adharNo}</td>
                                                <td>{item.pincode}</td>
                                                <td>{item.gstNo}</td>
                                                <td>{item.storeType}</td>
                                                <td>{item.status}</td>
                                                <td>{item.creationDate}</td>
                                                <td>{item.modificationDate}</td>
                                                <td>
                                                    <button className="btn btn-sm _themebg-0 text-white mx-1" onClick={() => editMeDetail(item)}>Edit</button>
                                                </td>
                                            </tr>
                                        )
                                    })}
                            </tbody>
                        </table>
                    </div>

                    <div style={{ display: editForm ? 'block' : 'none' }}>

                        <div className='border p-4'>
                            <div className='row mb-3'>
                                <div className='col-md-12'>
                                    <h6 className="bg-secondary text-white p-2 mb-3">Basic Details</h6>
                                </div>
                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">User Id <strong className='text-danger'>*</strong></label>
                                        <input id="userid" type="text" className="form-control shadow-none" defaultValue={meDetails.userId} disabled />
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label"> Company / Store Name <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none" defaultValue={meDetails.companyOrStoreName} disabled />
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">User Name <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none" defaultValue={meDetails.ownerName} disabled />
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">Mobile No. <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none" defaultValue={meDetails.mobileNo} disabled />
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">Alternate Mobile No. <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none" defaultValue={meDetails.alternateMobileNo} disabled />
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">User Email <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none" defaultValue={meDetails.emailId} disabled />
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">Nature Of Business <strong className='text-danger'>*</strong></label>
                                        <select id="natureofbusiness" className="form-select shadow-none" value={meDetails.natureOfBusiness || ''}  disabled >
                                            <option value="">--Select--</option>
                                            <option value="retail">Retail</option>
                                            <option value="insurance">Insurance</option>
                                            <option value="education">Education</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">Business Type <strong className='text-danger'>*</strong></label>
                                        <select className="form-select shadow-none" value={meDetails.businessType || ''} disabled >
                                            <option value="">--Select--</option>
                                            <option value="pvt ltd">Pvt Ltd</option>
                                            <option value="llp">LLP</option>
                                            <option value="proprietorship">Proprietorship</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">Address/Locality <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none" defaultValue={meDetails.localityOrAddress} disabled />
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">City <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none" defaultValue={meDetails.city} disabled />
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">State <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none" defaultValue={meDetails.state} disabled />
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">Country <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none" defaultValue={meDetails.country} disabled />
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">PinCode <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none" defaultValue={meDetails.pincode} disabled />
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">Store Type <strong className='text-danger'>*</strong></label>
                                        <select className="form-select shadow-none" value={meDetails.storeType || ''} disabled >
                                            <option value="">--Select--</option>
                                            <option value="physical">Physical</option>
                                            <option value="online">Online</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">Aadhar No. <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none" defaultValue={meDetails.adharNo} disabled />
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">Pan No. <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none" defaultValue={meDetails.panNo} disabled />
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">Gst No. <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none" defaultValue={meDetails.gstNo} disabled />
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className='border p-4 mt-4'>
                            <form onSubmit={handleSubmit(submitMeDetailForm)}>
                            <div className='row mb-3'>
                                <div className='col-md-12'>
                                    <h6 className="bg-secondary text-white p-2 mb-3">Advance Details</h6>
                                </div>

                                <div className='col-md-12 mb-2'>
                                    <label className="form-label">Product <strong className='text-danger'>*</strong></label>
                                    <ul className="list-group list-group-horizontal" ref={prodRef}>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="PAYIN" id="prodcheck_1" {...register('products')} />
                                                <label className="form-check-label" htmlFor="prodcheck_1">PAYIN</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="PAYOUT" id="prodcheck_2" {...register('products')} />
                                                <label className="form-check-label" htmlFor="prodcheck_2">PAYOUT</label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                  <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">IP CHECK <strong className='text-danger'>*</strong></label>
                                        <select className="form-select shadow-none _editP" id="ipCheck"
                                            {...register('ipCheck', { required: { value: true, message: "This field is required" } })}>
                                            <option value="">--Select--</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                        {errors.currency && <strong className="text-danger"><small>{errors.currency.message}</small></strong>}
                                    </div>
                                </div>

                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">IP / URL. <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.ipOrUrl}
                                            {...register('ipOrUrl', { required: { value: true, message: "This field is required" } })} />
                                        {errors.ipOrUrl && <strong className="text-danger"><small>{errors.ipOrUrl.message}</small></strong>}
                                    </div>
                                </div>

                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">MCC <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.mcc}
                                            {...register('mcc', { required: { value: true, message: "This field is required" } })} />
                                        {errors.mcc && <strong className="text-danger"><small>{errors.mcc.message}</small></strong>}
                                    </div>
                                </div>

                                <div className='col-md-3'>
                                    <div className="mb-2">
                                        <label className="form-label">Currency <strong className='text-danger'>*</strong></label>
                                        <select className="form-select shadow-none _editP" id="currency"
                                            {...register('currency', { required: { value: true, message: "This field is required" } })}>
                                            <option value="">--Select--</option>
                                            <option value="INR">INR</option>
                                            <option value="EURO">EURO</option>
                                        </select>
                                        {errors.currency && <strong className="text-danger"><small>{errors.currency.message}</small></strong>}
                                    </div>
                                </div>
                               
                                
                                <div className="d-flex">
                                <div className='mb-2 me-4'>
                                    <label className="form-label">Merchant Type <strong className='text-danger'>*</strong></label>
                                    <ul className="list-group list-group-horizontal" ref={meTypeRef}>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input shadow-none _editP" type="radio" value="MOTO" id="mtradio_1"
                                                    {...register('merchantType')} />
                                                <label className="form-check-label" htmlFor="mtradio_1">MOTO</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input shadow-none _editP" type="radio" value="SSL" id="mtradio_2"
                                                    {...register('merchantType')} />
                                                <label className="form-check-label" htmlFor="mtradio_2">SSL</label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div className='mb-2'>
                                    <label className="form-label">Status <strong className='text-danger'>*</strong></label>
                                    <ul className="list-group list-group-horizontal" ref={statusRef}>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input shadow-none _editP" type="radio" value="Activated" id="statusradio_1"
                                                    {...register('status')} />
                                                <label className="form-check-label" htmlFor="statusradio_1">ACTIVATED</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input shadow-none _editP" type="radio" value="Deactivated" id="statusradio_2"
                                                    {...register('status')} />
                                                <label className="form-check-label" htmlFor="statusradio_2">DEACTIVATED</label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                 {/* <div className='col-md-3'> */}
                                    <div className="mb-0" style={{marginLeft:"10px",marginBottom:"5px"}}>
                                        <label className="form-label">Payin Charge Deduction<strong className='text-danger'>*</strong></label>
                                        <select className="form-select shadow-none _editP" id="payinChargeDeductionMode"
                                            {...register('payinChargeDeductionMode', { required: { value: true, message: "This field is required" } })}>
                                            <option value="">--Select--</option>
                                            <option value="WALLET">WALLET</option>
                                            <option value="DIRECT">DIRECT</option>
                                        </select>
                                        {errors.payinChargeDeductionMode && <strong className="text-danger"><small>{errors.payinChargeDeductionMode.message}</small></strong>}
                                    </div>
                                {/* </div> */}




                                
                                </div>

                                <div className='col-md-12 mb-2'>
                                    <label className="form-label">Please Select Payment Mode <strong className='text-danger'>*</strong></label>
                                    <ul className="list-group list-group-horizontal" ref={pmtModeRef}>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="CARD" id="pmcheck_1" {...register('paymentMode')} />
                                                <label className="form-check-label" htmlFor="pmcheck_1">CARD</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="IB" id="pmcheck_2" {...register('paymentMode')} />
                                                <label className="form-check-label" htmlFor="pmcheck_2">IB</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="WALLET" id="pmcheck_3" {...register('paymentMode')} />
                                                <label className="form-check-label" htmlFor="pmcheck_3">WALLET</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="UPI" id="pmcheck_4" {...register('paymentMode')} />
                                                <label className="form-check-label" htmlFor="pmcheck_4">UPI</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="FT" id="pmcheck_5" {...register('paymentMode')} />
                                                <label className="form-check-label" htmlFor="pmcheck_5">FUND TRANSFER</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="AV" id="pmcheck_6" {...register('paymentMode')} />
                                                <label className="form-check-label" htmlFor="pmcheck_5">Account Verification</label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div className='col-md-12 mb-2'>
                                    <label className="form-label">Please Select Payment Mode Category<strong className='text-danger'>*</strong></label>
                                    <ul className="list-group list-group-horizontal" ref={pmtModeCatRef}>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="UPII" id="pmccheck_1" {...register('paymodeCategory')} />
                                                <label className="form-check-label" htmlFor="pmccheck_1">UPII</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="UPIC" id="pmccheck_2" {...register('paymodeCategory')} />
                                                <label className="form-check-label" htmlFor="pmccheck_2">UPIC</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="UPIONQR" id="pmccheck_3" {...register('paymodeCategory')} />
                                                <label className="form-check-label" htmlFor="pmccheck_3">UPI ON QR</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="UPIOFFQR" id="pmccheck_4" {...register('paymodeCategory')} />
                                                <label className="form-check-label" htmlFor="pmccheck_4">UPI OFF QR</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="IMPS" id="pmccheck_5" {...register('paymodeCategory')} />
                                                <label className="form-check-label" htmlFor="pmccheck_5">IMPS</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="RTGS" id="pmccheck_6" {...register('paymodeCategory')} />
                                                <label className="form-check-label" htmlFor="pmccheck_6">RTGS</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="NEFT" id="pmccheck_7" {...register('paymodeCategory')} />
                                                <label className="form-check-label" htmlFor="pmccheck_7">NEFT</label>
                                            </div>
                                        </li>


                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="PD" id="pmccheck_8" {...register('paymodeCategory')} />
                                                <label className="form-check-label" htmlFor="pmccheck_8">PENNY DROP</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="PL" id="pmccheck_9" {...register('paymodeCategory')} />
                                                <label className="form-check-label" htmlFor="pmccheck_9">PENNY LESS</label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="row">

                                <div className='col-md-4'>
                                    <div className="mb-2">
                                        <label className="form-label">Payin Min Ticket Size <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails?.payinMinTicketSize}
                                            {...register('payinMinTicketSize', { required: { value: true, message: "This field is required" } })} />
                                        {errors.ipOrUrl && <strong className="text-danger"><small>{errors.ipOrUrl.message}</small></strong>}
                                    </div>
                                </div>
                                  <div className='col-md-4'>
                                    <div className="mb-2">
                                        <label className="form-label">Payin Max Ticket Size <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails?.payinMaxTicketSize}
                                            {...register('payinMaxTicketSize', { required: { value: true, message: "This field is required" } })} />
                                        {errors.ipOrUrl && <strong className="text-danger"><small>{errors.ipOrUrl.message}</small></strong>}
                                    </div>
                                </div>

                                <div className='col-md-4'>
                                    <div className="mb-2">
                                        <label className="form-label">Payin Max Day Limit<strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.payinMaxDayLimit}
                                            {...register('payinMaxDayLimit', { required: { value: true, message: "This field is required" } })} />
                                        {errors.mcc && <strong className="text-danger"><small>{errors.mcc.message}</small></strong>}
                                    </div>
                                </div>
                                </div>
                                 <div className="row">
                                <div className='col-md-4'>
                                    <div className="mb-2">
                                        <label className="form-label">Payout Min Ticket Size<strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.payoutMinTicketSize}
                                            {...register('payoutMinTicketSize', { required: { value: true, message: "This field is required" } })} />
                                        {errors.ipOrUrl && <strong className="text-danger"><small>{errors.ipOrUrl.message}</small></strong>}
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className="mb-2">
                                        <label className="form-label">Payout Max Ticket Size<strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.payoutMaxTicketSize}
                                            {...register('payoutMaxTicketSize', { required: { value: true, message: "This field is required" } })} />
                                        {errors.ipOrUrl && <strong className="text-danger"><small>{errors.ipOrUrl.message}</small></strong>}
                                    </div>
                                </div>

                                <div className='col-md-4'>
                                    <div className="mb-2">
                                        <label className="form-label">payout Max Day Limit <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.payoutMaxDayLimit}
                                            {...register('payoutMaxDayLimit', { required: { value: true, message: "This field is required" } })} />
                                        {errors.mcc && <strong className="text-danger"><small>{errors.mcc.message}</small></strong>}
                                    </div>
                                </div>
                                </div>
{/* -----------Change------------------- */}

<label className="form-label">Map Reseller<strong className='text-danger'>*</strong></label>
                                 

<div className="col-4 d-flex gap-5">
    {/* {console.log("aa--",meDetails?.reName) } */}
<select className="form-select shadow-none _editP" id="reName"
    {...register('reName', { required: { value: true, message: "This field is required" } })} onChange={(e)=>resIdHandler(e.target.value)}>
       
        {meDetails?.reName ? <option value={meDetails?.reName}>{meDetails?.reName}</option>: <option value="">--Select--</option> }
        {/* {console.log("resName--",resName)} */}
        
        {resName?.map((item,index)=>{
           return <option value={item} key={index}>{item}</option>  
        })}
    </select>
    {errors.reName && <strong className="text-danger"><small>{errors.reName.message}</small></strong>}
                                    


    <select className="form-select shadow-none _editP" id="reUserId"
    {...register('reUserId', { required: { value: true, message: "This field is required" } })} >
        {meDetails?.reUserId ? <option value={meDetails?.reUserId}>{meDetails?.reUserId}</option>: <option value="">--Select--</option> }
     
        
        {resId?.map((item,index)=>{
           return <option value={item} key={index}>{item}</option>  
        })}
    </select>
    {errors.reUserId && <strong className="text-danger"><small>{errors.reUserId.message}</small></strong>}



</div>


{/* -----------Change------------------- */}



                            </div>
                            <div className='col-12 d-flex justify-content-center'>
                                <button type='submit' className="btn _themebg-0 text-white mx-1">UPDATE</button>
                            </div>
                            </form>
                        </div>

                        <div className="border p-4 mt-4 addprocbox" id="payin">
                            <form className='addprocform' onSubmit={handleSubmit2(submitAddProc)}>
                                <div className='row mb-3'>
                                    <div className='col-md-12'>
                                        <h6 className="bg-secondary text-white p-2 mb-3">Add Processor ( Payin )</h6>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Processor Name <strong className='text-danger'>*</strong></label>
                                            <select className="form-select shadow-none _getmid" onInput={getProcMid}
                                                {...register2('procName', { required: { value: true, message: "This field is required" } })}>
                                                <option value="">--Select--</option>
                                                <option value="SELFOFQR">SELFOFQR</option>
                                                <option value="TESTBANK">TESTBANK</option>
                                                <option value="SPAY">SPAY</option>
                                                <option value="PAYWIZE">PAYWIZE</option>
                                                <option value="ROOTPAY">ROOTPAY</option>
                                                
                                            </select>
                                            {errors2.procName && <strong className="text-danger"><small>{errors2.procName.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Payment Mode <strong className='text-danger'>*</strong></label>
                                            <select className="form-select shadow-none _getmid" onInput={getProcMid}
                                                {...register2('paymentMode', { required: { value: true, message: "This field is required" } })}>
                                                <option value="">--Select--</option>
                                                <option value="UPI">UPI</option>
                                            </select>
                                            {errors2.paymentMode && <strong className="text-danger"><small>{errors2.paymentMode.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Payment Mode Category <strong className='text-danger'>*</strong></label>
                                            <select className="form-select shadow-none _getmid" onInput={getProcMid}
                                                {...register2('paymentModeCategory', { required: { value: true, message: "This field is required" } })}>
                                                <option value="">--Select--</option>
                                                <option value="UPII">UPII</option>
                                                <option value="UPIC">UPIC</option>
                                                <option value="UPIONQR">UPIONQR</option>
                                                <option value="UPIOFFQR">UPIOFFQR</option>
                                            </select>
                                            {errors2.paymentModeCategory && <strong className="text-danger"><small>{errors2.paymentModeCategory.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        {/* <div className="mb-2">
                                            <label className="form-label">Processor Mid <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none" onInput={typeNumber}
                                                {...register2('procMid', { required: { value: true, message: "This field is required" } })} />
                                            {errors2.procMid && <strong className="text-danger"><small>{errors2.procMid.message}</small></strong>}
                                        </div> */}
                                        <div className="mb-2">
                                            <label className="form-label">Processor Mid <strong className='text-danger'>*</strong></label>
                                            <select className="form-select shadow-none _procmid" onInput={getProcDetails} 
                                                {...register2('procMid', { required: { value: true, message: "This field is required" } })}>
                                                <option value="">--Select--</option>
                                            </select>
                                            {errors2.procMid && <strong className="text-danger"><small>{errors2.procMid.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Msf Charges <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none" onInput={typeFloatNumber}
                                                {...register2('msfCharges', { required: { value: true, message: "This field is required" } })} />
                                            {errors2.msfCharges && <strong className="text-danger"><small>{errors2.msfCharges.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Msf Charges Gst <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none" onInput={typeFloatNumber}
                                                {...register2('msfChargesGst', { required: { value: true, message: "This field is required" } })} />
                                            {errors2.msfChargesGst && <strong className="text-danger"><small>{errors2.msfChargesGst.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Convinience Charges <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none" onInput={typeFloatNumber}
                                                {...register2('convinienceCharges', { required: { value: true, message: "This field is required" } })} />
                                            {errors2.msfChargesGst && <strong className="text-danger"><small>{errors2.msfChargesGst.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Convinience Charges Gst <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none" onInput={typeFloatNumber}
                                                {...register2('convinienceChargesGst', { required: { value: true, message: "This field is required" } })} />
                                            {errors2.convinienceChargesGst && <strong className="text-danger"><small>{errors2.convinienceChargesGst.message}</small></strong>}
                                        </div>
                                    </div>
                                   
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Charge Type <strong className='text-danger'>*</strong></label>
                                            <select className="form-select shadow-none" onInput={stopTags}
                                                {...register2('chargeType', { required: { value: true, message: "This field is required" } })}>
                                                <option value="">--Select--</option>
                                                <option value="MSF">MSF</option>
                                                <option value="CONVINIENCE">CONVINIENCE</option>
                                            </select>
                                            {errors2.chargeType && <strong className="text-danger"><small>{errors2.chargeType.message}</small></strong>}
                                        </div>
                                    </div>
                                     <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Fee Type <strong className='text-danger'>*</strong></label>
                                            <select className="form-select shadow-none" onInput={stopTags}
                                                {...register2('feeType', { required: { value: true, message: "This field is required" } })}>
                                                <option value="">--Select--</option>
                                                <option value="P">PERCENT</option>
                                                <option value="F">FLAT</option>
                                            </select>
                                            {errors2.feeType && <strong className="text-danger"><small>{errors2.feeType.message}</small></strong>}
                                        </div>
                                    </div>
                                    
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Slab<strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none" onInput={typeNumber}
                                                {...register2('slab', { required: { value: true, message: "This field is required" } })} />
                                            {errors2.slab && <strong className="text-danger"><small>{errors2.slab.message}</small></strong>}
                                        </div>
                                    </div>
                                    
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Reseller Commision <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none" onInput={typeFloatNumber}
                                                {...register2('resellerCommision', { required: { value: true, message: "This field is required" } })} />
                                            {errors2.resellerCommision && <strong className="text-danger"><small>{errors2.resellerCommision.message}</small></strong>}
                                        </div>
                                    </div>
                                    
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Processor Credentials 1 <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none _focusProc" value={fetchProcDtl.procCred_1||''} onInput={stopTags}
                                                {...register2('procCred_1', { required: { value: true, message: "This field is required" } })} />
                                            {errors2.procCred_1 && <strong className="text-danger"><small>{errors2.procCred_1.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Processor Credentials 2 <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none _focusProc" value={fetchProcDtl.procCred_2||''} onInput={stopTags}
                                                {...register2('procCred_2', { required: { value: true, message: "This field is required" } })} />
                                            {errors2.procCred_2 && <strong className="text-danger"><small>{errors2.procCred_2.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Processor Credentials 3 <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none _focusProc" value={fetchProcDtl.procCred_3||''} onInput={stopTags}
                                                {...register2('procCred_3', { required: { value: true, message: "This field is required" } })} />
                                            {errors2.procCred_3 && <strong className="text-danger"><small>{errors2.procCred_3.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Processor Credentials 4 <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none _focusProc" value={fetchProcDtl.procCred_4||''} onInput={stopTags}
                                                {...register2('procCred_4', { required: { value: true, message: "This field is required" } })} />
                                            {errors2.procCred_4 && <strong className="text-danger"><small>{errors2.procCred_4.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Processor Credentials 5 <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none _focusProc" value={fetchProcDtl.procCred_5||''} onInput={stopTags}
                                                {...register2('procCred_5', { required: { value: true, message: "This field is required" } })} />
                                            {errors2.procCred_5 && <strong className="text-danger"><small>{errors2.procCred_5.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Processor Url <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none _focusProc" value={fetchProcDtl.procUrl||''} onInput={stopTags}
                                                {...register2('procUrl', { required: { value: true, message: "This field is required" } })} />
                                            {errors2.procUrl && <strong className="text-danger"><small>{errors2.procUrl.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <button type="submit" className="btn _themebg-0 text-white">ADD</button>
                                    </div>
                                </div>
                            </form>
                            {/* Processor table */}
                            <div className="table-responsive">
                                <table className="table table-bordered com-table">
                                    <thead>
                                        <tr>
                                            <th>User Id</th>
                                            <th>Mid</th>
                                            <th>Processor Name</th>
                                            <th>Payment Mode</th>
                                            <th>Payment Mode Category</th>
                                            <th>Charge Type</th>
                                            
                                            <th style={{paddingLeft: "50px",paddingRight: "50px"}}>Fee Type</th>
                                            <th style={{paddingLeft: "50px",paddingRight: "50px"}}>Slab</th>

                                            <th>Msf Charges</th>
                                            <th>Msf Charges Gst</th>
                                            <th>Convinience Charges</th>
                                            <th>Convinience Charges Gst</th>
                                            <th>Reseller Commision</th>
                                            <th>Processor Mid</th>
                                            <th>Processor Credentials 1</th>
                                            <th>Processor Credentials 2</th>
                                            <th>Processor Credentials 3</th>
                                            <th>Processor Credentials 4</th>
                                            <th>Processor Credentials 5</th>
                                            <th>Processor Url </th>
                                            <th>Creation Date</th>
                                            <th>Modified Date</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* {console.log("procData--->>",procData)} */}
                                        {procData.length === 0 ? <tr><td colSpan={11}>Not Found</td></tr> :
                                            procData.map((item) => {
                                                return (
                                                    <tr key={item.id}>
                                                        <td>{item.user_id}</td>
                                                        <td>{item.mid}</td>
                                                        <td>
                                                            <select className="form-select shadow-none form-select-sm _editProc" name="procName" defaultValue={item.proc_name}>
                                                                <option value="SELFOFQR">SELFOFQR</option>
                                                                <option value="TESTBANK">TESTBANK</option>
                                                                <option value="SPAY">SPAY</option>   
                                                                <option value="PAYWIZE">PAYWIZE</option>
                                                                <option value="ROOTPAY">ROOTPAY</option>
                                                            </select>
                                                        </td>
                                                        <td>{item.payment_mode}</td>
                                                        <td>{item.payment_mode_category}</td>
                                                        <td>
                                                            <select className="form-select shadow-none form-select-sm _editProc" name="chargeType" defaultValue={item.charge_type}>
                                                                <option value="MSF">MSF</option>
                                                                <option value="CONVINIENCE">CONVINIENCE</option>
                                                            </select>
                                                        </td>

                                                        <td >
                                                          
                                                            <select className="form-select shadow-none form-select-sm _editProc" name="feeType" defaultValue={item.fee_type}
                                                            >
                                                               <option value="P">PERCENT</option>
                                                                <option value="F">FLAT</option>
                                                            </select>
                                                        </td>

                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="slab" defaultValue={item.slab} onInput={typeNumber} /></td>

                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="msfCharges" defaultValue={item.msf_charges} onInput={typeFloatNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="msfChargesGst" defaultValue={item.msf_charges_gst} onInput={typeFloatNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="convinienceCharges" defaultValue={item.convinience_charges} onInput={typeFloatNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="convinienceChargesGst" defaultValue={item.convinience_charges_gst} onInput={typeFloatNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="resellerCommision" defaultValue={item.reseller_commision} onInput={typeFloatNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="procMid" defaultValue={item.proc_mid} onInput={typeNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="procCred_1" defaultValue={item.proc_cred_1} onInput={typeNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="procCred_2" defaultValue={item.proc_cred_2} onInput={typeNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="procCred_3" defaultValue={item.proc_cred_3} onInput={typeNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="procCred_4" defaultValue={item.proc_cred_4} onInput={typeNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="procCred_5" defaultValue={item.proc_cred_5} onInput={typeNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="procUrl" defaultValue={item.proc_url} onInput={typeNumber} /></td>
                                                        <td>{item.creation_date}</td>
                                                        <td>{item.modification_date}</td>
                                                        <td>
                                                            <button className="btn btn-sm border-success text-success mx-1"><i className="fa-solid fa-pen-to-square" onClick={(e) => editProc(e, item.id)}></i></button>
                                                            <button className="btn btn-sm border-danger text-danger mx-1"><i className="fa-solid fa-trash-can" onClick={(e) => deleteProc(e,item.id)}></i></button>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                    </tbody>
                                </table>
                            </div>
                            {/* Processor table */}
                        </div>

                        <div className="border p-4 mt-4 addprocbox" id="payout">
                            <form className='addprocform' onSubmit={handleSubmit3(submitAddProc)}>
                                <div className='row mb-3'>
                                    <div className='col-md-12'>
                                        <h6 className="bg-secondary text-white p-2 mb-3">Add Processor ( Payout )</h6>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Processor Name <strong className='text-danger'>*</strong></label>
                                            <select className="form-select shadow-none _getmid" onInput={getProcMid}
                                                {...register3('procName', { required: { value: true, message: "This field is required" } })}>
                                                <option value="">--Select--</option>
                                                <option value="SELFOFQR">SELFOFQR</option>
                                                <option value="TESTBANK">TESTBANK</option>
                                                <option value="SPAY">SPAY</option>
                                                <option value="BENACPAY">BENACPAY</option>
                                                <option value="PAYWIZE">PAYWIZE</option>
                                                <option value="ROOTPAY">ROOTPAY</option>
                                            </select>
                                            {errors3.procName && <strong className="text-danger"><small>{errors3.procName.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Payment Mode <strong className='text-danger'>*</strong></label>
                                            <select className="form-select shadow-none _getmid" onInput={getProcMid}
                                                {...register3('paymentMode', { required: { value: true, message: "This field is required" } })}>
                                                <option value="">--Select--</option>
                                                <option value="FT">FUND TRANSFER</option>
                                            </select>
                                            {errors3.paymentMode && <strong className="text-danger"><small>{errors3.paymentMode.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Payment Mode Category <strong className='text-danger'>*</strong></label>
                                            <select className="form-select shadow-none _getmid" onInput={getProcMid}
                                                {...register3('paymentModeCategory', { required: { value: true, message: "This field is required" } })}>
                                                <option value="">--Select--</option>
                                                <option value="IMPS">IMPS</option>
                                                <option value="RTGS">RTGS</option>
                                                <option value="NEFT">NEFT</option>
                                            </select>
                                            {errors3.paymentModeCategory && <strong className="text-danger"><small>{errors3.paymentModeCategory.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        {/* <div className="mb-2">
                                            <label className="form-label">Processor Mid <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none" onInput={typeNumber}
                                                {...register2('procMid', { required: { value: true, message: "This field is required" } })} />
                                            {errors3.procMid && <strong className="text-danger"><small>{errors3.procMid.message}</small></strong>}
                                        </div> */}
                                        <div className="mb-2">
                                            <label className="form-label">Processor Mid <strong className='text-danger'>*</strong></label>
                                            <select className="form-select shadow-none _procmid" onInput={getProcDetails} 
                                                {...register3('procMid', { required: { value: true, message: "This field is required" } })}>
                                                <option value="">--Select--</option>
                                            </select>
                                            {errors3.procMid && <strong className="text-danger"><small>{errors3.procMid.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Msf Charges <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none" onInput={typeFloatNumber}
                                                {...register3('msfCharges', { required: { value: true, message: "This field is required" } })} />
                                            {errors3.msfCharges && <strong className="text-danger"><small>{errors3.msfCharges.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Msf Charges Gst <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none" onInput={typeFloatNumber}
                                                {...register3('msfChargesGst', { required: { value: true, message: "This field is required" } })} />
                                            {errors3.msfChargesGst && <strong className="text-danger"><small>{errors3.msfChargesGst.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Convinience Charges <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none" onInput={typeFloatNumber}
                                                {...register3('convinienceCharges', { required: { value: true, message: "This field is required" } })} />
                                            {errors3.msfChargesGst && <strong className="text-danger"><small>{errors3.msfChargesGst.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Convinience Charges Gst <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none" onInput={typeFloatNumber}
                                                {...register3('convinienceChargesGst', { required: { value: true, message: "This field is required" } })} />
                                            {errors3.convinienceChargesGst && <strong className="text-danger"><small>{errors3.convinienceChargesGst.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Charge Type <strong className='text-danger'>*</strong></label>
                                            <select className="form-select shadow-none" onInput={stopTags}
                                                {...register3('chargeType', { required: { value: true, message: "This field is required" } })}>
                                                <option value="">--Select--</option>
                                                <option value="MSF">MSF</option>
                                                <option value="CONVINIENCE">CONVINIENCE</option>
                                            </select>
                                            {errors3.chargeType && <strong className="text-danger"><small>{errors3.chargeType.message}</small></strong>}
                                        </div>
                                    </div>

                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Fee Type <strong className='text-danger'>*</strong></label>
                                            <select className="form-select shadow-none" onInput={stopTags}
                                                {...register3('feeType', { required: { value: true, message: "This field is required" } })}>
                                                <option value="">--Select--</option>
                                                <option value="P">PERCENT</option>
                                                <option value="F">FLAT</option>
                                            </select>
                                            {errors2.feeType && <strong className="text-danger"><small>{errors2.feeType.message}</small></strong>}
                                        </div>
                                    </div>
                                    
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Slab<strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none" onInput={typeNumber}
                                                {...register3('slab', { required: { value: true, message: "This field is required" } })} />
                                            {errors2.slab && <strong className="text-danger"><small>{errors2.slab.message}</small></strong>}
                                        </div>
                                    </div>

                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Reseller Commision<strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none" onInput={typeFloatNumber}
                                                {...register3('resellerCommision', { required: { value: true, message: "This field is required" } })} />
                                            {errors3.resellerCommision && <strong className="text-danger"><small>{errors3.resellerCommision.message}</small></strong>}
                                        </div>
                                    </div>

                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Processor Credentials 1 <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none _focusProc2" value={fetchProcDtl_2.procCred_1||''} onInput={stopTags}
                                                {...register3('procCred_1', { required: { value: true, message: "This field is required" } })} />
                                            {errors3.procCred_1 && <strong className="text-danger"><small>{errors3.procCred_1.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Processor Credentials 2 <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none _focusProc2" value={fetchProcDtl_2.procCred_2||''} onInput={stopTags}
                                                {...register3('procCred_2', { required: { value: true, message: "This field is required" } })} />
                                            {errors3.procCred_2 && <strong className="text-danger"><small>{errors3.procCred_2.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Processor Credentials 3 <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none _focusProc2" value={fetchProcDtl_2.procCred_3||''} onInput={stopTags}
                                                {...register3('procCred_3', { required: { value: true, message: "This field is required" } })} />
                                            {errors3.procCred_3 && <strong className="text-danger"><small>{errors3.procCred_3.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Processor Credentials 4 <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none _focusProc2" value={fetchProcDtl_2.procCred_4||''} onInput={stopTags}
                                                {...register3('procCred_4', { required: { value: true, message: "This field is required" } })} />
                                            {errors3.procCred_4 && <strong className="text-danger"><small>{errors3.procCred_4.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Processor Credentials 5 <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none _focusProc2" value={fetchProcDtl_2.procCred_5||''} onInput={stopTags}
                                                {...register3('procCred_5', { required: { value: true, message: "This field is required" } })} />
                                            {errors3.procCred_5 && <strong className="text-danger"><small>{errors3.procCred_5.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="mb-2">
                                            <label className="form-label">Processor Url <strong className='text-danger'>*</strong></label>
                                            <input type="text" className="form-control shadow-none _focusProc2" value={fetchProcDtl_2.procUrl||''} onInput={stopTags}
                                                {...register3('procUrl', { required: { value: true, message: "This field is required" } })} />
                                            {errors3.procUrl && <strong className="text-danger"><small>{errors3.procUrl.message}</small></strong>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <button type="submit" className="btn _themebg-0 text-white">ADD</button>
                                    </div>
                                </div>
                            </form>
                            {/* Processor table */}
                            <div className="table-responsive">
                                <table className="table table-bordered com-table">
                                    <thead>
                                        <tr>
                                            <th>User Id</th>
                                            <th>Mid</th>
                                            <th>Processor Name</th>
                                            <th>Payment Mode</th>
                                            <th>Payment Mode Category</th>
                                            <th>Charge Type</th>

                                             
                                            <th style={{paddingLeft: "50px",paddingRight: "50px"}}>Fee Type</th>
                                            <th style={{paddingLeft: "50px",paddingRight: "50px"}}>Slab</th>



                                            <th>Msf Charges</th>
                                            <th>Msf Charges Gst</th>
                                            <th>Convinience Charges</th>
                                            <th>Convinience Charges Gst</th>
                                            <th>Reseller Commision</th>
                                            <th>Processor Mid</th>
                                            <th>Processor Credentials 1</th>
                                            <th>Processor Credentials 2</th>
                                            <th>Processor Credentials 3</th>
                                            <th>Processor Credentials 4</th>
                                            <th>Processor Credentials 5</th>
                                            <th>Processor Url </th>
                                            <th>Creation Date</th>
                                            <th>Modified Date</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {procDataPayout.length === 0 ? <tr><td colSpan={11}>Not Found</td></tr> :
                                            procDataPayout.map((item) => {
                                                return (
                                                    <tr key={item.id}>
                                                        <td>{item.user_id}</td>
                                                        <td>{item.mid}</td>
                                                        <td>
                                                            <select className="form-select shadow-none form-select-sm _editProc" name="procName" defaultValue={item.proc_name}>
                                                               <option value="SELFOFQR">SELFOFQR</option>
                                                               <option value="TESTBANK">TESTBANK</option>
                                                                <option value="SPAY">SPAY</option>
                                                                <option value="BENACPAY">BENACPAY</option>
                                                                <option value="PAYWIZE">PAYWIZE</option>
                                                                <option value="ROOTPAY">ROOTPAY</option>
                                                                
                                                            </select>
                                                        </td>
                                                        <td>{item.payment_mode}</td>
                                                        <td>{item.payment_mode_category}</td>
                                                        <td>
                                                            <select className="form-select shadow-none form-select-sm _editProc" name="chargeType" defaultValue={item.charge_type}>
                                                                <option value="MSF">MSF</option>
                                                                <option value="CONVINIENCE">CONVINIENCE</option>
                                                            </select>
                                                        </td>

                                                        <td >
                                                          
                                                            <select className="form-select shadow-none form-select-sm _editProc" name="feeType" defaultValue={item.fee_type}
                                                            >
                                                               <option value="P">PERCENT</option>
                                                                <option value="F">FLAT</option>
                                                            </select>
                                                        </td>

                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="slab" defaultValue={item.slab} onInput={typeNumber} /></td>


                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="msfCharges" defaultValue={item.msf_charges} onInput={typeFloatNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="msfChargesGst" defaultValue={item.msf_charges_gst} onInput={typeFloatNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="convinienceCharges" defaultValue={item.convinience_charges} onInput={typeFloatNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="convinienceChargesGst" defaultValue={item.convinience_charges_gst} onInput={typeFloatNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="resellerCommision" defaultValue={item.reseller_commision} onInput={typeFloatNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="procMid" defaultValue={item.proc_mid} onInput={typeNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="procCred_1" defaultValue={item.proc_cred_1} onInput={typeNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="procCred_2" defaultValue={item.proc_cred_2} onInput={typeNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="procCred_3" defaultValue={item.proc_cred_3} onInput={typeNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="procCred_4" defaultValue={item.proc_cred_4} onInput={typeNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="procCred_5" defaultValue={item.proc_cred_5} onInput={typeNumber} /></td>
                                                        <td><input type="text" className="form-control form-control-sm shadow-none _editProc" name="procUrl" defaultValue={item.proc_url} onInput={typeNumber} /></td>
                                                        <td>{item.creation_date}</td>
                                                        <td>{item.modification_date}</td>
                                                        <td>
                                                            <button className="btn btn-sm border-success text-success mx-1"><i className="fa-solid fa-pen-to-square" onClick={(e) => editProc(e, item.id)}></i></button>
                                                            <button className="btn btn-sm border-danger text-danger mx-1"><i className="fa-solid fa-trash-can" onClick={(e) => deleteProc(e,item.id)}></i></button>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                    </tbody>
                                </table>
                            </div>
                            {/* Processor table */}
                        </div>

                        <button type='button' className="btn btn-secondary rounded-0 mt-4 w-100" onClick={() => setEditForm(false)}>CLOSE</button>
                    </div>
                </div>
            </div>
        </div>
    </>)
}